module.exports = __webpack_public_path__ + "5add2d55403f5343cb6e30add2dfd46f.pdf";